<div class="flex flex-col gap-2">
  <!-- select round -->
  <p-select [options]="playoffs" [optionLabel]="'name'" [(ngModel)]="selectedRound"
    appendTo="body" (onChange)="changeRound()" [style]="{ width: '100%' }" [className]="'round-select'" />
  <!-- playoffs matches -->
  @if(selectedRound && matches.length) {
    <app-matches [matches]="matches" [stage]="'PLAYOFFS'" [isFinal]="isFinal"
      (changePiecesEvent)="selectedRound.id && getMatches(selectedRound.id)"
      (updateEvent)="isFinal && updateTournament($event)"></app-matches>
  }
  <!-- winner -->
  @if(isFinal && winner) {
    <div class="winner flex flex-col gap-4 justify-center text-center">
      <i class="pi pi-trophy"></i>
      <span>{{ winner.name }}</span>
    </div>
  }
  <!-- positioning matches -->
  @if(selectedRound && positioningMatches.length) {
    <div class="flex flex-col mt-4">
      <div class="positioning">
        {{ 'positioning' | translate }}
      </div>
      <app-matches [matches]="positioningMatches" [stage]="'PLAYOFFS'"
        (changePiecesEvent)="selectedRound.id && getMatches(selectedRound.id)"></app-matches>
    </div>
  }
  <!-- consolation matches -->
  @if(selectedRound && consolationMatches.length) {
    <div class="flex flex-col mt-4">
      <div class="consolation">
        {{ 'consolation' | translate }}
      </div>
      <app-matches [matches]="consolationMatches" [stage]="'PLAYOFFS'" [consolation]="true"></app-matches>
    </div>
  }
</div>